import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class LocalStorage {
    private static readonly PREFERRED_LANG: string = 'pref_lang';
    private static readonly ACCESS_TOKEN: string = 'access_token';
    private static readonly REFRESH_TOKEN: string = 'refresh_token';
    private static readonly USER_PROFILE: string = 'userProfile';
    private static readonly LOGIN_SUCCESS: string = 'login_success';
    
    public preferredLang: BehaviorSubject<string>;
    public userAccessToken: BehaviorSubject<string>;
    public userRefreshToken: BehaviorSubject<string>;
    public userProfile: BehaviorSubject<string>;

    constructor() {
        this.preferredLang = new BehaviorSubject(localStorage.getItem(LocalStorage.PREFERRED_LANG));
        this.userAccessToken = new BehaviorSubject(
            localStorage.getItem(LocalStorage.ACCESS_TOKEN)
        );
        this.userRefreshToken = new BehaviorSubject(
            localStorage.getItem(LocalStorage.REFRESH_TOKEN)
        );
        this.userProfile = new BehaviorSubject(
            localStorage.getItem(LocalStorage.USER_PROFILE)
        );
    }

    public static getPreferredLang() : string {
        return localStorage.getItem(LocalStorage.PREFERRED_LANG);
    }

    setPreferredLang(lang: string): void {
        localStorage.setItem(LocalStorage.PREFERRED_LANG, lang);

        this.preferredLang.next(lang);
    }

    getAccessToken(): string | null {
        return localStorage.getItem(LocalStorage.ACCESS_TOKEN);
    } 
    
    setAccessToken(token: string): void {
        localStorage.setItem(LocalStorage.ACCESS_TOKEN, token);
        this.userAccessToken.next(token);
    }

    getRefreshToken(): string | null {
        return localStorage.getItem(LocalStorage.REFRESH_TOKEN);
    } 
    
    setRefreshToken(token: string): void {
        localStorage.setItem(LocalStorage.REFRESH_TOKEN, token);
        this.userRefreshToken.next(token);
    }

    getUserProfile(): any {
        const raw = localStorage.getItem('userProfile');
        return raw ? JSON.parse(raw) : null;
    }

    setUserProfile(profile: any): void {
        localStorage.setItem(LocalStorage.USER_PROFILE, JSON.stringify(profile));
    }

    setLoginSuccessFlag(): void {
        localStorage.setItem(LocalStorage.LOGIN_SUCCESS, 'true');
    }

    getLoginSuccessFlag(): boolean {
        return localStorage.getItem(LocalStorage.LOGIN_SUCCESS) === 'true';
    }
    
    clearAll() {
        localStorage.clear();
    }

}